const boostDetails = {
  pdsButton: 'Read our Policy',
  boostHeader: {
    primaryButton: {
      add: 'Add to Trip',
      mandatory: 'Mandatory',
      notEligible: 'Not eligible',
      remove: 'Remove',
    },
  },
} as const;

export default boostDetails;
